module.exports = __webpack_public_path__ + "img/mp3.a28bccd4.svg";